export default __webpack_public_path__ + "static/media/blog-img86.2a6b7228.jpg";